import { SelectFormGroup } from "../select-form-group/select-form-group";
import { BaseSelectFormGroupProps } from "./base-select-form-group-props";
import { TimeRangeTypes } from "@enums/time-range-types";
import { useMemo } from "react";
import { getTimeRangeLabel } from "@utils/date-util";
import { resources } from "@constants/hardcoded-strings";

type TimeRangeSelectFormGroupProps = BaseSelectFormGroupProps & {
    timeRangeTypes: Array<TimeRangeTypes>
};

export const TimeRangeSelectFormGroup = (props: TimeRangeSelectFormGroupProps) => {
    const { timeRangeTypes, onChange, selectedOption, idPrefix, disabled, isRequired, isSearchable, isClearable, labelWidth, layout } = props;

    const timeRangeOptions = useMemo(() => {
        return timeRangeTypes.map(trt => ({ label: getTimeRangeLabel(trt), value: trt }));
    }, [timeRangeTypes]);

    return (
        <SelectFormGroup
            controlId={`${idPrefix}-time-range-select`}
            label={resources.common.searchForm.filters.timeRange.label}
            ariaLabel={resources.common.searchForm.filters.timeRange.label}
            automationId={`${idPrefix}-time-range-select`}
            onChange={onChange}
            options={timeRangeOptions}
            selectedOption={selectedOption}
            disabled={disabled}
            isRequired={isRequired}
            isSearchable={isSearchable}
            isClearable={isClearable}
            labelWidth={labelWidth}
            layout={layout}
        />
    );
};